/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const RegistryModelOrigin = {
  Api: "api",
  Yaml: "yaml",
} as const;
export type RegistryModelOrigin = ClosedEnum<typeof RegistryModelOrigin>;

/** @internal */
export const RegistryModelOrigin$inboundSchema: z.ZodNativeEnum<
  typeof RegistryModelOrigin
> = z.nativeEnum(RegistryModelOrigin);
/** @internal */
export const RegistryModelOrigin$outboundSchema: z.ZodNativeEnum<
  typeof RegistryModelOrigin
> = RegistryModelOrigin$inboundSchema;
